import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export const CTAStrip = ({
  eyebrow = "Ready when you are",
  title = "Stop buying lists. Start buying performance.",
  buttonText = "Talk to sales",
  to = "/contact",
}) => {
  return (
    <section
      data-testid="cta-strip"
      className="bg-citirex-ink text-citirex-inv"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-6 py-20 md:grid-cols-12 md:px-12 md:py-28">
        <div className="md:col-span-8">
          <p className="overline">{eyebrow}</p>
          <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl">
            {title}
          </h2>
        </div>
        <div className="md:col-span-4 md:flex md:justify-end">
          <Link
            to={to}
            data-testid="cta-strip-button"
            className="group inline-flex items-center gap-2 bg-citirex-accent px-7 py-5 font-body text-sm font-semibold uppercase tracking-wider text-citirex-inv transition-colors hover:bg-citirex-accentDark"
          >
            {buttonText}
            <ArrowUpRight
              size={18}
              weight="bold"
              className="transition-transform group-hover:rotate-45"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTAStrip;
